import React from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

const RunCodeButton = ({ theme, disabled, submitCode, loading = false }) => {
  const { t } = useTranslation('common');

  return (
    <Button
      type="primary"
      disabled={disabled || loading}
      onClick={() => submitCode()}
      data-testid="run-code-button-footer"
      data-track="click"
      data-track-category="CodeEditor"
      data-track-label="run-code-button"
      ghost
      loading={loading}
      style={{
        border: disabled ? '1px solid #d9d9d9' : '1px solid var(--selector-marker)',
        width: '100px',
        height: '40px',
        margin: '0 8px',
        borderRadius: '2px',
      }}
    >
      {t('editor.run_code_button')}
    </Button>
  );
};

export default RunCodeButton;
